type SortableClassroom = {
  classType?: string | null;
};

const classroomNameCollator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base",
});

export const compareClassroomTypes = (a: SortableClassroom, b: SortableClassroom): number => {
  const aRank = a.classType === "KINDERGARTEN" ? 0 : 1;
  const bRank = b.classType === "KINDERGARTEN" ? 0 : 1;
  return aRank - bRank;
};

export const compareClassroomNames = (a: string, b: string): number =>
  classroomNameCollator.compare(a, b);
